(function () {
  document.querySelectorAll('.currency-selector-select').forEach(function (select) {
    select.addEventListener('change', function (e) {
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          e.target.form.submit();
        })
        .catch(function (err) {
          console.error('Cart update failed:', err);
          if (
            window.notificationEle &&
            typeof window.notificationEle.updateNotification === 'function'
          ) {
            window.notificationEle.updateNotification(
              'Error',
              'Something went wrong while adding to cart.',
              { type: 'error', timeout: 5000 }
            );
          }
        });
    });
  });
})();
